import SeoLandingTemplate, { SeoLandingPageData } from "@/components/marketing/SeoLandingTemplate";

const page: SeoLandingPageData = {
  path: "/behavioral-interview-questions",
  title: "Behavioral Interview Questions and Answers",
  seoTitle: "Behavioral Interview Questions and Answers | HiredCoach",
  seoDescription:
    "Review common behavioral interview questions, how to answer them well, and how to practice them with AI feedback.",
  heroEyebrow: "Behavioral prep",
  heroHeadline: "Behavioral questions get ugly when your stories are still vague",
  heroSubhead:
    "You usually know the experience. That is not the problem. The problem is saying it clearly, fast, and without losing the useful part halfway through.",
  heroPrimaryCta: "Practice these out loud",
  heroPanelEyebrow: "What actually works",
  heroPanelTitle: "Build a small story bank",
  heroPanelBullets: [
    "Cover conflict, pressure, leadership, mistakes, and wins",
    "Keep each story tight",
    "Make your action and result obvious",
  ],
  heroPanelFooter: "If the story stays vague, the answer falls apart.",
  frameworkTitle: "How to make your stories usable",
  frameworkBullets: [
    "Build 5 to 7 stories that cover conflict, pressure, leadership, mistakes, and wins.",
    "Use one structure so you do not start wandering under pressure.",
    "Keep the setup short. Spend your time on what you did.",
    "Always land the result. Otherwise the story just floats there.",
  ],
  exampleTitle: "What a good story sounds like",
  exampleBlocks: [
    "Briefly set the context.",
    "Explain the disagreement or challenge.",
    "Describe how you handled it directly and calmly.",
    "Show what changed because of your actions.",
  ],
  exampleFooter: "The result can be a better process, a repaired relationship, or a measurable outcome.",
  mistakesTitle: "Why behavioral answers get messy",
  mistakes: [
    "You spend forever setting up the story.",
    "You describe the team and disappear from your own example.",
    "You never really land the result.",
    "You use one blurry story for everything.",
  ],
  ctaEyebrow: "Coach U + practice",
  ctaTitle: "Practice these with AI interviewer",
  ctaBullets: [
    "Pick the right stories",
    "Keep the setup short",
    "Make your action obvious",
    "Land the result",
  ],
  ctaInfoCard: {
    title: "Coach U article library",
    path: "/public-learn",
    description: "Browse interview prep content and build a stronger story bank.",
  },
  ctaActionTitle: "Practice these out loud",
  ctaActionDescription: "Use real prompts, hear what feels thin, and tighten your stories before interview day.",
  relatedTitle: "More interview questions worth actually practicing",
  relatedLinks: [
    {
      title: "STAR Method Interview Examples",
      path: "/star-method",
      description: "Learn the STAR method with clear interview examples, common mistakes, and a practical CTA to turn your experience into stronger answers.",
    },
    {
      title: "Common Interview Questions",
      path: "/common-interview-questions",
      description: "Use this hub page to prepare for the most common interview questions and jump into deeper answer guides and mock interview practice.",
    },
    {
      title: "How to Prepare for an Interview",
      path: "/how-to-prepare-for-an-interview",
      description: "A practical interview preparation guide covering research, answer practice, story prep, and mock interview rehearsal.",
    },
  ],
  faqs: [
    { question: "What are behavioral interview questions?", answer: "They are questions about how you handled real situations in the past, often starting with 'Tell me about a time when...'" },
    { question: "How many stories should you prepare?", answer: "Usually 5 to 7. Enough to cover the big themes without sounding like you memorized a novel." },
  ],
};

export default function BehavioralInterviewQuestionsPage() {
  return <SeoLandingTemplate page={page} />;
}
